import request from '@/router/axios';

const getList = params => request({
  url: '/api/blade-flow/manager/list',
  method: 'get',
  params: {
    ...params,
  },
})
const getAiisToken = params => request({
  url: '/api/mcc-open/open-flow/token',
  method: 'get',
  params: {
    ...params,
  },
})

export default {
  getList,
  getAiisToken,
};
